<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <o-widget-wrapper
      :schema="schema"
      name="name"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.name"
        :form-state="formState"
        name="name"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.name"
      ></o-text-field>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="code"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.code"
        :form-state="formState"
        name="code"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.code"
      ></o-text-field>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="type"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.type"
        :items="codeTriggerTypeItems"
        text-field="description"
        value-field="id"
        sort-field="description"
        :form-state="formState"
        name="type"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.type"
        store-name="CodeTriggerType"
        @input="changeType"
      >
      </o-select>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="params"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <b-container fluid="xs" class="my-4">
        <b-row>
          <b-col class="text-right pr-0">Params</b-col>
          <b-col cols="10">
            <template v-if="!item.type">
              <p class="text-italic text-600">Select type</p>
            </template>
            <b-form-input
              v-if="item.type == 1"
              v-model="item.params.buttonText"
              type="text"
              placeholder="Button Label"
              @input="validateForm"
            ></b-form-input>
            <b-form-input
              @input="validateForm"
              placeholder="Timeout Minutes"
              v-if="item.type == 2"
              v-model="item.params.timeout"
              type="number"
              step="1"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-container>

      <b-container v-if="checkItemType" fluid="xs" class="my-4">
        <b-row>
          <b-col class="text-right pr-0">Select button color</b-col>
          <b-col cols="10">
            <b-form-select
              v-model="item.params.variant"
              :options="buttonTriggerColor"
            ></b-form-select>
          </b-col>
        </b-row>
      </b-container>

      <!-- <o-text-field
        v-if="item.type == 2"
        v-model="item.params.timeout"
        :form-state="formState"
        name="params"
        step="1"
        type="number"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.params"
      ></o-text-field> -->
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="details"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-textarea
        v-model="item.details"
        :form-state="formState"
        name="details"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.details"
      ></o-textarea>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="roles"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-multi-checkbox
        :form-state="formState"
        :items="itemRolesId"
        :server-errors="_se"
        :validators="$v.item"
        name="roles"
        sort-field="description"
        text-field="description"
        v-bind="schema.fields.roles"
        v-model="item.roles"
        value-field="id"
      ></o-multi-checkbox>
      <div class="form-row">
        <div
          class="col-lg-2 col-3 bv-no-focus-ring col-form-label text-right"
        ></div>
        <div class="col">
          <template v-if="checkItemRoleId.length > 0" class="container">
            <p class="text-italic text-600">Update to see all User Roles</p>
          </template>
        </div>
      </div>
    </o-widget-wrapper>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextarea from "../../../../vue-ocom/components/forms/fields/OTextarea";
import OTextField from "../../../../vue-ocom/components/forms/fields/OTextField";

import OSelect from "../../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../../vue-ocom/components/forms/fields/ODateTime";
import OMultiCheckbox from "../../../../vue-ocom/components/forms/fields/OMultiCheckbox.vue";

import _ from "lodash";
import { default as CodeTriggerTypeForm } from "../../code_trigger_type/components/ItemForm";
import { button_trigger_color } from "@/vue-workflow/lib/code_tables/button_trigger_color.js";
// import { default as TriggerUserRoleFormTable } from "../../trigger_user_role/components/ItemFormTable";
// import { default as TriggerUserRoleFormCards } from '../../trigger_user_role/components/ItemFormCards';

export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("ProcessTrigger"),
    CreateCodeTableFetchMixin([]),
  ],
  components: {
    OMultiCheckbox,
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextarea,
    OTextField,

    CodeTriggerTypeForm,
    // TriggerUserRoleFormTable,
    //TriggerUserRoleFormCards,
  },
  props: {
    codeTriggerTypeItems: { type: Array, default: () => [] },
    itemParams: { type: Array, default: () => [] },
    itemRoles: { type: Array, default: () => [] },
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.ProcessTrigger, {}),
    buttonTriggerColor: button_trigger_color,
  }),
  methods: {
    validateForm() {
      if (this.formState) this.formState.dirty = true;
    },
    changeType(item) {
      if (item == 3 || item == 1) {
        this.item.params.button_color = 1;
      }
      this.item.params = this.item.params || {};
    },
    updateRolesSelected(items) {
      this.item.roles = items;
    },
  },
  computed: {
    checkItemType() {
      // insure that the item.type is button
      if (this.item.type == 1 || this.item.type == 3) {
        return true;
      }

      return false;
    },
    itemRolesId() {
      const result = this.itemRoles.filter(
        (i) => i.id != null || i.id != undefined || i.id
      );
      return result;
    },
    checkItemRoleId() {
      const result = this.itemRoles.filter(
        (i) => i.id == null || i.id == undefined || !i.id
      );
      return result;
    },
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
  },
  watch: {},
  created() {
    if (this.checkItemType) {
      this.item.params.button_color = 1;
    }
  },
};
</script>

<style scoped>
.text-italic {
  font-style: italic;
}
.text-600 {
  font-weight: 600;
}
</style>
